// extracted by mini-css-extract-plugin
export default {"apiRankBox":"apiRank_apiRankBox__tQE-d","rankBox":"apiRank_rankBox__foO0-","bigBox":"apiRank_bigBox__uWFsb"};